(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  document.addEventListener('DOMContentLoaded', function() {
    function isIE() {
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE ');
      const trident = ua.indexOf('Trident/');

      return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function(event) {
      document.querySelector('#cart').submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-mito-stores"] && !Shopify.designMode) return;
  try {
    
if (window.matchMedia('(min-width: 1280px)').matches) {
// remove slider on desktop
    var store_section = document.querySelectorAll(".store-section")
    var swiper_wrapper = document.querySelectorAll(".store-div")
    var slide = document.querySelectorAll(".store-wrapper")
    store_section.forEach(e => e.classList.remove("store-swiper"))
    slide.forEach(e => e.classList.remove("swiper-slide"))
    swiper_wrapper.forEach(e => e.classList.remove("swiper-wrapper"))
} else {
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-accordeon-event"] && !Shopify.designMode) return;
  try {
    
window.onload = function(e) {
  if (window.matchMedia("(min-width: 754px)").matches) {
    let show_eventcontent_tab = document.querySelector("#show_eventcontent_tab");
    let show_agenda_tab = document.querySelector("#show_agenda_tab");
    let show_eventloc_tab = document.querySelector("#show_eventloc_tab");

    function openTab(evt, tabName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      if(tabName == 'eventloc_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'agenda_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'eventcontent_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else {
        document.getElementById(tabName).style.display = "block";
      }
      evt.currentTarget.className += " active";
    }

    if(show_eventcontent_tab != undefined) {
      show_eventcontent_tab.addEventListener("click", (event) => {
        openTab(event, 'eventcontent_tab')
      });
    }
    if(show_agenda_tab != undefined) {
      show_agenda_tab.addEventListener("click", (event) => {
        openTab(event, 'agenda_tab')
      });
    }
    if(show_eventloc_tab != undefined) {
      show_eventloc_tab.addEventListener("click", (event) => {
        openTab(event, 'eventloc_tab')
      });
    }
    if(show_eventref_tab != undefined) {
      show_eventref_tab.addEventListener("click", (event) => {
        openTab(event, 'eventref_tab')
      });
    }

    if (show_agenda_tab != undefined){
      show_agenda_tab.click()
    } else if(show_eventref_tab != undefined) {
      show_eventref_tab.click();
    } else if (show_eventloc_tab != undefined){
      show_eventloc_tab.click()
    }
  } else {

    var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-accordeon"] && !Shopify.designMode) return;
  try {
    
window.onload = function(e) {
  if (window.matchMedia("(min-width: 754px)").matches) {
    let show_ingredients_tab = document.querySelector("#show_ingredients_tab");
    let show_desc_tab = document.querySelector("#show_desc_tab");
    let show_active_ingredients_tab = document.querySelector("#show_active_ingredients_tab");
    let show_application_tab = document.querySelector("#show_application_tab");
    let show_health_claims_tab = document.querySelector("#show_health_claims_tab");
    let show_lab_tab = document.querySelector("#show_lab_tab");
    let show_review_tab = document.querySelector("#show_review_tab");

    function openTab(evt, tabName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
          tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
          tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      if(tabName == 'ingredients_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'desc_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'application_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'active_ingredients_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else if(tabName == 'lab_tab') {
        document.getElementById(tabName).style.display = "grid";
      } else {
        document.getElementById(tabName).style.display = "block";
      }
      evt.currentTarget.className += " active";
    }

    if(show_review_tab != undefined) {
      show_review_tab.addEventListener("click", (event) => {
        openTab(event, 'reviews_tab')
      });
    }
    if(show_ingredients_tab != undefined) {
      show_ingredients_tab.addEventListener("click", (event) => {
        openTab(event, 'ingredients_tab')
      });
    }
    if(show_desc_tab != undefined) {
      show_desc_tab.addEventListener("click", (event) => {
        openTab(event, 'desc_tab')
      });
    }
    if(show_active_ingredients_tab != undefined) {
      show_active_ingredients_tab.addEventListener("click", (event) => {
        openTab(event, 'active_ingredients_tab')
      });
    }
    if(show_application_tab != undefined) {
      show_application_tab.addEventListener("click", (event) => {
        openTab(event, 'application_tab')
      });
    }
    if(show_health_claims_tab != undefined) {
      show_health_claims_tab.addEventListener("click", (event) => {
        openTab(event, 'health_claims_tab')
      });
    }
    if(show_lab_tab != undefined) {
      show_lab_tab.addEventListener("click", (event) => {
        openTab(event, 'lab_tab')
      });
    }

    if (show_desc_tab != undefined){
      show_desc_tab.click()
    } else if(show_ingredients_tab != undefined) {
      show_ingredients_tab.click();
    } else if (show_active_ingredients_tab != undefined){
      show_active_ingredients_tab.click()
    } else if (show_application_tab != undefined){
      show_application_tab.click()
    } else if (show_health_claims_tab != undefined){
      show_health_claims_tab.click()
    } else if (show_lab_tab != undefined){
      show_lab_tab.click()
    }
  } else {

    var acc = document.getElementsByClassName("accordion");
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-tabs"] && !Shopify.designMode) return;
  try {
    
  window.onload = function (e) {
    var acc = document.getElementsByClassName('accordion');
    var i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    

  if (window.matchMedia('(min-width: 640px').matches) {
    // make slider go right to left
    var testimonials = document.getElementById("swiper-testimonials")
    if(testimonials == undefined) return
    testimonials.dir = "rtl"
  }


  } catch(e) { console.error(e); }
})();
})();
